<template>
    <Toolbar>
        <template #start>
            <slot name="left"></slot>
        </template>

        <template #end>
            <slot name="right"></slot>
        </template>
    </Toolbar>
</template>

<script>
import Toolbar from 'primevue/toolbar';

export default {
    name: 'tw-toolbar',
    components: {
        Toolbar
    }
}

</script>